type ResettableStore = { getState(): { reset(): void } };

// Zustand keeps no registry of its own, so each store opts in here to be cleared on logout.
const resettable = new Set<ResettableStore>();

/** Opt a Zustand store into {@link resetStores}. Call once, at the store's definition site. */
export function registerResettable<T extends ResettableStore>(store: T): T {
  resettable.add(store);
  return store;
}

/** Reset every store registered via {@link registerResettable}. */
export function resetStores(): void {
  for (const store of resettable) {
    store.getState().reset();
  }
}
